/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('revenuePlanningService', revenuePlanningService);

    revenuePlanningService.$inject = ['$http', 'CONFIG', 'messageService'];

    function revenuePlanningService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API ;
        var service = {
            updateSegmentItineraries: updateSegmentItineraries,
            getRouteItinerariesRevenuePlan: getRouteItinerariesRevenuePlan
        }

        return service;

        function updateSegmentItineraries(segmentItineraries){
            return $http.put(urlBase + "/segmentItineraries/plan" , segmentItineraries)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function getRouteItinerariesRevenuePlan(itineraryId,makerId_modelId,page, size){
            var url = '/routeItineraries/revenue/plans/'+itineraryId+'?page=' + page + '&size=' + size;
            if (makerId_modelId !== "") {
                url = url + '&makerId_modelId=' + makerId_modelId;
            }
            return $http.get(urlBase+ url)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }
    }
})();

